import { CapacitorHttp } from '@capacitor/core';


export type RuntimeConfig = {
    baseApiUrl: string;
}

export type EnvConfig = {
    env: string;
}

const GLOBAL_CONFIG = {
    development: {
        baseApiUrl: "http://localhost:8090"
    },
    prod: {
        baseApiUrl: "https://api.rogueintuitionlabs.org"
    }
}


import { Capacitor } from '@capacitor/core';
import { getAndroidEnvConfig } from './androidConfig';

function isAndroidNative(): boolean {
    // true only when running as a native Android app (not web)
    return Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'android';
}

function normalizeJson<T>(data: unknown): T {
    if (typeof data === 'string') {
        return JSON.parse(data) as T;
    }

    if (typeof data === 'object' && data !== null) {
        return data as T;
    }

    throw new Error('Unexpected HTTP response data type');
}

export async function getEnvConfig(): Promise<EnvConfig> {
    if (isAndroidNative()) {
        const configResponse = await CapacitorHttp.get({ url:"https://rogueintuitionlabs.org/envConfig.json" });
        return normalizeJson<EnvConfig>(configResponse.data);
    }

    const configResponse = await fetch("/envConfig.json", { cache: "no-store" });
    return await configResponse.json();
}

let cachedConfig: RuntimeConfig | null = null;
export async function loadRuntimeConfig(): Promise<RuntimeConfig> {
    if (!cachedConfig) {
        const envConfig = await getEnvConfig()
        cachedConfig = GLOBAL_CONFIG[envConfig.env];
    }

    return cachedConfig;
}
